import { InjectionToken } from '@angular/core';

export interface ValidatorsConfiguration {
  address: { enabled: boolean; required: boolean; regex: string };
  personName: {
    enabled: boolean;
    required: boolean;
    regex: string;
  };
  msisdn: {
    enabled: boolean;
    required: boolean;
    regex: string;
  };
  idNumber: {
    enabled: boolean;
    required: boolean;
    regex: string;
  };
  burialSocietyName: {
    enabled: boolean;
    required: boolean;
    regex: string;
  };
}

export const VALIDATORS_CONFIGURATION_TOKEN = new InjectionToken<
  ValidatorsConfiguration
>('Configure Validators Globally');
